var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSplit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.19434 9.99219C6.19434 9.57797 6.53012 9.24219 6.94434 9.24219H13.0554C13.4697 9.24219 13.8054 9.57797 13.8054 9.99219C13.8054 10.4064 13.4697 10.7422 13.0554 10.7422H6.94434C6.53012 10.7422 6.19434 10.4064 6.19434 9.99219Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9051 1.66602H6.09556C3.37334 1.66602 1.66699 3.59275 1.66699 6.32031V13.6784C1.66699 16.4059 3.3654 18.3327 6.09556 18.3327H13.9051C16.6352 18.3327 18.3337 16.4059 18.3337 13.6784V6.32031C18.3337 3.59275 16.6352 1.66602 13.9051 1.66602Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplit);
export default __webpack_public_path__ + "static/media/split.a44b53e753fd72f0a68a419338714246.svg";
export { ForwardRef as ReactComponent };